import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2422654294/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
